import { UUID } from 'crypto';
import createAxiosInstance from './axiosConfig';
import { FiltroLogDTO } from '../shared/dto/filtroLogDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/logController');

export default class LogService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarLogLoginPorFiltro(currentPage: number, max: number, filtro: FiltroLogDTO) {
    return await this.axios.post(`/listarLogLoginPorFiltro?page=${currentPage}&max=${max}`, filtro);
  };

  async listarLogTransacaoPorFiltro(currentPage: number, max: number, filtro: FiltroLogDTO) {
    return await this.axios.post(`/listarLogTransacaoPorFiltro?page=${currentPage}&max=${max}`, filtro);
  };

  async listarLogTransacaoPorId(id: UUID) {
    return await this.axios.get(`/listarLogTransacaoPorId?id=${id}`);
  };

  async listarLogConsultaMargemPorFiltro(currentPage: number, max: number, filtro: FiltroLogDTO) {
    return await this.axios.post(`/listarLogConsultaMargemPorFiltro?page=${currentPage}&max=${max}`, filtro);
  };

  async listarLogSimulacaoPorFiltro(currentPage: number, max: number, filtro: FiltroLogDTO) {
    return await this.axios.post(`/listarLogSimulacaoPorFiltro?page=${currentPage}&max=${max}`, filtro);
  };

  async listarTiposTransacaoLog() {
    return await this.axios.get(`/listarTiposTransacaoLog`);
  };
}